import { Component, ErrorHandler, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import * as sortBy from 'lodash/sortBy';

import { State } from '../../util/states';
import { AirportSearchResult } from '../../airport/models/airport-search-result.model';
import { PromiseState, StatefulPromise } from '../../util/stateful-promise';
import { AirportService } from '../../airport/airport.service';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-state-airports',
  templateUrl: './state-airports.component.html',
  styleUrls: ['./state-airports.component.scss']
})
export class StateAirportsComponent implements OnInit {
  state: State;
  airportsPromise: StatefulPromise<AirportSearchResult[]>;

  constructor(
    private _airportService: AirportService,
    private _route: ActivatedRoute,
    private _meta: Meta,
    private _title: Title,
    private _errorHandler: ErrorHandler
  ) { }

  get sortedAirports(): Array<AirportSearchResult> {
    if (this.airportsPromise.state !== PromiseState.Fulfilled) {
      return [];
    }
    return sortBy(this.airportsPromise.value, ['identifier']);
  }

  ngOnInit() {
    this._route.data
      .subscribe((data: { state: State }) => {
        this.state = data.state;
        this._updateMeta();
        this.airportsPromise = new StatefulPromise(
          this._airportService.getAirportsByState(this.state.stateCode, true)
        );
      }, (error: any) => {
        this._errorHandler.handleError(error);
      });
  }

  private _updateMeta() {
    this._title.setTitle(`Airports in ${this.state.name} - ${environment.appName}`);
    this._meta.removeTag('name="description"');
  }
}
